/* eslint-disable */
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Icon from "@material-ui/core/Icon";
// core components
import Button from "components/CustomButtons/Button.jsx";
import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx";
import { urlConstants } from "../../constants";

function HeaderLinks({ ...props }) {
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const smoothScroll = (e, target) => {
    if (window.location.pathname === "/sections") {
      var isMobile = navigator.userAgent.match(
        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
      );
      if (isMobile) {
        // if we are on mobile device the scroll into view will be managed by the browser
      } else {
        e.preventDefault();
        var targetScroll = document.getElementById(target);
        scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
      }
    }
  };
  const scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };
  var onClickSections = {};
  const { classes, dropdownHoverColor } = props;
  return (
    <List className={classes.list + " "
        + classes.mlAuto + " "
        + classes.marginTopSmall50
    }>
      <ListItem>
        <span className={
          classes.margin0Auto
        }>
          <a
              href="tel:004401452238064"
              className={classes.whiteColorText}
          >
            <Icon className={classes.phoneIcon}>
              phone
            </Icon>
            01215 822 533
          </a>
        </span>
      </ListItem>
      <ListItem className={
        classes.lineAfter
      }>
      </ListItem>
      <ListItem className={classes.listItem +  " "
          + classes.paddingRight16
      }>
        <Button
          href={urlConstants.LOGIN_PAGE}
          color={window.innerWidth < 960 ? "success" : "white"}
          className={
            classes.navButton + " "
          }
          round
        >
          Login
        </Button>
      </ListItem>
      <ListItem className={classes.listItem +  " "
      + classes.paddingRight16
      }>
        <Button
            href={urlConstants.SIGNUP_PAGE}
            color={window.innerWidth < 960 ? "success" : "white"}
            className={classes.navButton}
            round
        >
          Sign up
        </Button>
      </ListItem>

      <ListItem className={classes.listItem  +  " "
      + classes.paddingRight16
      }>
        <Button
            href={urlConstants.BLOG_PAGE}
            color={window.innerWidth < 960 ? "success" : "white"}
            className={classes.navButton}
            round
        >
          BLOG
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
            href={urlConstants.PRICING_PAGE}
            color={window.innerWidth < 960 ? "success" : "white"}
            className={classes.navButton}
            round
        >
          PRICING
        </Button>
      </ListItem>
    </List>
  );
}

HeaderLinks.defaultProps = {
  hoverColor: "primary"
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ])
};

export default withStyles(headerLinksStyle)(HeaderLinks);
